import React from "react";
import PropTypes from "prop-types";
import Banner from "@p1s/p1s-common-react/entities/Banner";
import DOMPurify from "dompurify";

export const Announcement = ({ announcement }) => {
    const announcementIconClass = `announcement-icon ${announcement.iconClass}`;

    return (
        <div className="carousel-item">
            <div className="announcementTitle">
                {announcement.iconClass && <span className={announcementIconClass}/>}
                <span>{announcement.title}</span>
            </div>
            <div className="announcement-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(announcement.text) }}/>
            {announcement.hasButton &&
            <a className="link-button" href={announcement.buttonLink}>
                <div className="learn-more-button">{announcement.buttonLabel}</div>
            </a>}
        </div>);
};

Announcement.propTypes = {
    announcement: PropTypes.instanceOf(Banner).isRequired
};

export default Announcement;
